import {PropositionStatus} from "../utils/types";
import {CheckCircleOutlined, HighlightOffOutlined, PendingOutlined} from "@mui/icons-material";
import {Box, Typography} from "@mui/material";
import React from "react";

export function StatusMessage({status}: { status: PropositionStatus }) {
    switch (status) {
        case "SENT":
            return <Box sx={{display: "inline-flex", gap: 1, verticalAlign: "middle"}}>
                <PendingOutlined sx={{height: "100%"}}/>
                <Typography>Avaliação pendente</Typography>
            </Box>
        case "APPROVED":
            return <Box sx={{display: "inline-flex", gap: 1, verticalAlign: "middle"}}>
                <CheckCircleOutlined sx={{height: "100%", color: "#00D387"}}/>
                <Typography>Proposta aprovada</Typography>
            </Box>
        case "DENIED":
            return <Box sx={{display: "inline-flex", gap: 1, verticalAlign: "middle"}}>
                <HighlightOffOutlined sx={{height: "100%", color: "#FF5E51"}}/>
                <Typography>Proposta reprovada</Typography>
            </Box>
    }
}